import { observable, action } from 'mobx';
import firebaseService from '../FirebaseService';
import Utils from '../Utils';

class AnnouncementStore{
    @observable Announcements = [];
    @observable LoadingAnnouncements = false;
    @observable LoadingAnnouncementForUpdate = false;
    @observable ShowAddAnnouncement = false;
    @observable IsAddingAnnouncement = false;
    @observable AnnouncementIdToDelete = "";
    @observable IsDeletingAnnouncement = false;
    @observable AddAnnouncementRequest = {
        AnnouncementId: "",
        Content: "",
        AnnouncementDate: null,
        ExpiresOn: ""
    }
    @action UpdateAddAnnouncementRequestProperty(key, value) {
        this.AddAnnouncementRequest[key] = value;
    }
    @action GetAnnouncements(){
        this.LoadingAnnouncements = true;
        firebaseService.Announcements()
                    .then((snapshot)=>{
                        this.Announcements = [];
                        snapshot.forEach((childSnapshot)=>{
                            this.Announcements.unshift(childSnapshot.val());
                        })
                    })
                    .catch((err)=>{  console.log(err);  Utils.Toast.Error("Unable to retrieve announcements"); })
                    .finally(()=>{ this.LoadingAnnouncements = false;  });
    }
    @action ToggleAddAnnouncementModal(id) {
        if (id !== undefined && id !== null && id !== "") {
            this.LoadingAnnouncementForUpdate = true;
            firebaseService.GetAnnouncement(id)
                .then((snapshot) => {
                    var announcement = snapshot.val();
                    Utils.Basic.CopyTo(announcement, this.AddAnnouncementRequest);
                })
                .catch((err) => { console.log(err); Utils.Toast.Error("Unable to retrieve announcement with Id : " + id); })
                .finally(() => { this.LoadingAnnouncementForUpdate = false; })
        }
        else{
            this.AddAnnouncementRequest.AnnouncementId = "";
        }
        this.ShowAddAnnouncement = this.ShowAddAnnouncement ? false : true;
    }
    @action AddAnnouncement() {
        if (this.AddAnnouncementRequest.AnnouncementId === "") {
            this.IsAddingAnnouncement = true;
            firebaseService.AddAnnouncement(this.AddAnnouncementRequest)
                .then(() => {
                    this.ToggleAddAnnouncementModal();
                    this.GetAnnouncements();
                })
                .catch((err) => { console.log(err); Utils.Toast.Error("Unable to Add announcement"); })
                .finally(() => { this.IsAddingAnnouncement = false; })
        } else {
            this.IsAddingAnnouncement = true;
            firebaseService.UpdateAnnouncement(this.AddAnnouncementRequest)
                .then(() => {
                    this.ToggleAddAnnouncementModal();
                    this.GetAnnouncements();
                })
                .catch((err) => { console.log(err); Utils.Toast.Error("Unable to update announcement"); })
                .finally(() => { this.IsAddingAnnouncement = false; })
        }
    }
    @action DeleteAnnouncement(){
        this.IsDeletingAnnouncement = true;
        firebaseService.GetAnnouncement(this.AnnouncementIdToDelete)
        .then((snapshot) => {
          snapshot.ref.remove();
          this.GetAnnouncements();
        })
        .catch((err) => { console.log(err); Utils.Toast.Error("Unable to delete announcement"); })
        .finally(() => { this.IsDeletingAnnouncement = false; this.AnnouncementIdToDelete = ""; })
    }
}
export default new AnnouncementStore();


// WEBPACK FOOTER //
// ./src/stores/AnnouncementStore.js